import React, { useState } from "react";
import "./HelpSupport.css";
import GettingStarted from "./GetStarted.js";
import { useNavigate } from "react-router-dom";
import MyAccount from "./MyAccount";


export default function HelpSupport() {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("home"); 

  const faqs = [
    {
      question: "What is the uTECH Emission Analyzer used for?",
      answer:
        "The uTECH Emission Analyzer is a data-driven tool designed to help users understand how transportation activity contributes to emissions within a defined area. It simulates how variables such as vehicle type, traffic density, time range, and road conditions interact to influence overall emission levels.",
    },
    {
      question: "How accurate are the emission results?",
      answer:
        "The accuracy of your simulation depends on the quality and completeness of the input data. Results should be interpreted as modeled estimates, not live sensor readings.",
    },
    {
      question: "Do I need technical experience to use the app?",
      answer:
        "No advanced technical background is required. The interface is designed with guided steps and examples to help new users learn quickly.",
    },
    {
      question: "What type of data do I need to run a simulation?",
      answer:
        "You will need traffic and environmental data such as vehicle counts, speed, and density within a defined time and area.",
    },
    {
      question: "Can I upload my own traffic or vehicle data?",
      answer:
        "Yes, you can upload CSV or Excel datasets, which the app validates automatically before integration.",
    },
  ];

  const helpSections = [
    {
      key: "gettingStarted",
      title: "Getting Started",
      desc: "Learn how to set up your account, configure your projects, and navigate the app interface.",
      icon: "🖐️",
    },
    {
      key: "myAccount",
      title: "My Account",
      desc: "Manage your account details, update contact information, and view your saved scenarios.",
      icon: "👤",
    },
    {
      key: "pricing",
      title: "Pricing & Payments",
      desc: "View subscription plans, update billing information, and manage payment settings.",
      icon: "💳",
    },
    {
      key: "scenario",
      title: "Scenario Setup",
      desc: "Create and configure custom scenarios for data analysis and simulations.",
      icon: "⚙️",
    },
    {
      key: "data",
      title: "Data & Uploads",
      desc: "Learn how to upload datasets, connect APIs, and manage your data sources securely.",
      icon: "📂",
    },
    {
      key: "results",
      title: "Results & Visualizations",
      desc: "Explore output reports, visual dashboards, and analytical visualizations.",
      icon: "📊",
    },
  ];

  return (
    <div className="hs-page-container">
        <div className="hs-page">
        {activeSection === "home" ? (
            <>
            <header className="hs-header">
                <div className="hs-header-overlay">
                <h1 className="hs-title">How can we help?</h1>
                <div className="hs-search-bar">
                    <input
                    type="text"
                    placeholder="Search Help & Support"
                    className="hs-input"
                    />
                    <button className="hs-search-btn">🔍</button>
                </div>
                </div>
            </header>

            <section className="hs-section">
                <h2 className="hs-subtitle">Assistance Center</h2>
                <div className="hs-grid">
                {helpSections.map((item) => (
                    <button
                    key={item.key}
                    className="hs-card"
                    onClick={() => setActiveSection(item.key)}
                    >
                    <div className="hs-icon">{item.icon}</div>
                    <h3>{item.title}</h3>
                    <p>{item.desc}</p>
                    </button>
                ))}
                </div>
            </section>

            <section className="hs-section">
                <h2 className="hs-subtitle">Frequently Asked Questions</h2>
                <div className="hs-faq-container">
                {faqs.map((item, i) => (
                    <details key={i} className="hs-faq-item">
                    <summary className="hs-faq-question">
                        <span>{item.question}</span>
                        <span className="hs-faq-toggle">+</span>
                    </summary>
                    <pre className="hs-faq-answer">{item.answer}</pre>
                    </details>
                ))}
                </div>
            </section>
            </>
        ) : (
            <div className="hs-fullpage">
            

            {activeSection === "gettingStarted" && (
              <GettingStarted onBack={() => setActiveSection("home")} />
            )}
            {activeSection === "myAccount" && (
              <MyAccount onBack={() => setActiveSection("home")} />
            )}
            {activeSection === "pricing" && <h2>Pricing & Payments</h2>}
            {activeSection === "scenario" && <h2>Scenario Setup</h2>}
            {activeSection === "data" && <h2>Data & Uploads</h2>}
            {activeSection === "results" && <h2>Results & Visualizations</h2>}
            </div>
        )}
        </div>
    </div>
    );

}
